import { type TenantDto } from '../../../api/data-contracts';
import AppCheckInput from '../../components/forms/AppCheckInput';
import AppFormDropdownAnt from '../../components/forms/AppFormDropdownAnt';
import { useGetDimColumnOptionsQuery } from '../api/api';

interface Props {
  values: TenantDto;
}

function BiSpecificSettings({ values, }: Props) {
  const showBiSettings = values.editionId && values.editionId.toString() === '1';

  const { data, isFetching, } = useGetDimColumnOptionsQuery({ databaseName: values.databaseName ?? '', databaseServer: values.databaseServer ?? '' }, {
    skip: !showBiSettings || !values.databaseName,
  });

  if (!showBiSettings) { return <></>; }

  return (
    <>
      <h4 className='mt-4'>Mapping settings</h4>

      <div className="fv-row my-3">
        <AppCheckInput name="isMappingEnabled" label="Enable mapping for host" />
      </div>

      <div className="fv-row mb-5">
        <AppFormDropdownAnt
          mode="multiple"
          disabled={!values.isMappingEnabled}
          loading={isFetching}
          name="excludedTenantMappingColumnsList"
          options={data ?? []}
          label="Filter out columns for the company"
        />
      </div>

      <div className="separator mb-4" />
    </>
  );
}

export default BiSpecificSettings;
